import { FormEvent, FunctionComponent, useState } from 'react'
import axios from 'axios'

import { FieldLabel, FormGroup, FormRow } from '@components/undock/forms'
import {
  ContactFormInput,
  ContactFormTextarea,
  ContactFormWrapper,
  PrivacyLink,
  PrivacyStatement,
} from '@components/undock/forms/contact/style'
import { PrimaryButton } from '@components/undock/buttons'

const ContactForm: FunctionComponent = () => {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [subject, setSubject] = useState('')
  const [content, setContent] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault()

    try {
      const result = await (window as any).Email.send({
        Host: 'smtp.elasticemail.com',
        Port: 2525,
        Username: 'space@undock.com',
        Password:
          '37CAAC7BCD1994F3338ACB7ACABB69947B3C',
        To: 'space@undock.com',
        From: 'dan@undock.com',
        Subject: `New message from ${name} (${email}) via the Undock Website: ${subject}`,
        Body: `<html>
        <h2>New message from ${name} (${email}) via the Undock Website:</h2>
        <div>${content}</div>
        </html>`,
      })

      console.log(result)

      if (result == 'OK') {
        setEmail('')
        setName('')
        setSubject('')
        setContent('')
        alert(`Thank you for your message`);
        window.location.href = window.location.origin
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ContactFormWrapper onSubmit={handleSubmit}>
      <FormRow>
        <FormGroup count={2}>
          <FieldLabel>Name</FieldLabel>
          <ContactFormInput
            type="text"
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your full name..."
            value={name}
          />
        </FormGroup>
        <FormGroup count={2}>
          <FieldLabel>Email</FieldLabel>
          <ContactFormInput
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address..."
            value={email}
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup>
          <FieldLabel>Subject</FieldLabel>
          <ContactFormInput
            type="text"
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Enter the subject of your message..."
            value={subject}
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup>
          <FieldLabel>Message</FieldLabel>
          <ContactFormTextarea
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter your message..."
            value={content}
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <PrivacyStatement>
          By submitting this form, I confirm that I have read and understood the
          <PrivacyLink href="/l/legal/privacy-policy">
            &nbsp;Undock Privacy Statement
          </PrivacyLink>
          .
        </PrivacyStatement>
      </FormRow>
      <FormRow>
        <PrimaryButton style={{ margin: 'auto' }}>Send</PrimaryButton>
      </FormRow>
    </ContactFormWrapper>
  )
}

export default ContactForm
